export default __webpack_public_path__ + "static/media/roboto-v20-latin-900.f930b75b.eot";